'use client';

import { useEffect, useState } from 'react';

interface ProgressBarProps {
  value: number; // 0-100
  label: string;
  showValue?: boolean;
}

function getBarColor(value: number): string {
  if (value < 40) return 'bg-red-500';
  if (value < 70) return 'bg-amber-500';
  return 'bg-green-500';
}

export default function ProgressBar({ value, label, showValue = true }: ProgressBarProps) {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    // Delay to trigger animation
    const timeout = setTimeout(() => setWidth(value), 100);
    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium text-gray-700">{label}</span>
        {showValue && (
          <span className="text-sm font-bold text-gray-900">{value}%</span>
        )}
      </div>
      <div className="w-full h-2.5 bg-gray-200 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-700 ease-out ${getBarColor(value)}`}
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  );
}
